<script setup lang="ts">
import { styleFn } from 'shared/composables/usePage';
</script>

<template>
  <q-page
    :style-fn="styleFn"
    class="column q-px-md"
  >
    <slot />
  </q-page>
</template>
